import { useTheme, TypographyProps, Typography } from "@mui/material";

const BaseSelectItemTypo = (props: TypographyProps) => {
  const theme = useTheme();

  return (
    <Typography
      variant="body-default"
      color="text.secondary"
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        textAlign: "center",
        gap: theme.spacing(1),
        minHeight: "26px",
      }}
      {...props}>
      {props.children}
    </Typography>
  );
};

export default BaseSelectItemTypo;
